module.exports = __webpack_public_path__ + "img/vouchers506.d9f36c7a.png";